import Vue from 'vue'

const API = {
  // 登录操作
  login: (params) => {
    return Vue.axios.post('/api/customerlogin/', params)
  },
  // 获取验证码
  getVerifyCode: ({ mobile }) => {
    return Vue.axios.get(`/api/getverifycode/${mobile}/`)
  },
  // 获取当前登录用户信息
  currentUser: () => {
    return Vue.axios.get('/api/currentuser/')
  },
  // 实名认证
  renZheng: (params) => {
    return Vue.axios.post(`/api/customers/${params.id}/check/`, params)
  },
  // 获取问卷
  getQuestions: () => {
    return Vue.axios.get('/api/questionnaires/review/')
  },
  // 提交问卷
  submitQuestions: (data) => {
    return Vue.axios.post('/api/questionnaires/review/', data)
  },
  // 获取历史测评
  getReviews: () => {
    return Vue.axios.get('/api/customers/reviews/')
  },
  // 获取历史测评详情
  getReviewsDetail: (params) => {
    return Vue.axios.get(`/api/customers/reviews/${params.id}/`)
  },
  // 获取站点配置信息
  getSiteConfig: () => {
    return Vue.axios.get('/api/siteconfig/')
  },
  // 获取公司详情页
  getCompanyDetail: () => {
    return Vue.axios.get('/api/sites/current/')
  },
  // 获取首页至多三篇文章
  getArticlesTop3: () => {
    return Vue.axios.get('/api/articles/top/3/')
  },
  // 获取首页至多3支产品
  getProductsTop3: () => {
    return Vue.axios.get('/api/products/top/3/')
  },
  // 获取资讯列表
  getArticles: ({ page = 1 }) => {
    return Vue.axios.get(`/api/articles/?page=${page}`)
  },
  // 资讯详情
  getArticle: ({ id }) => {
    return Vue.axios.get(`/api/articles/${id}/`)
  },
  // 获取资讯标签
  getArticleTags: () => {
    return Vue.axios.get('/api/tags/')
  },
  getArticlesByTag: ({ id, page = 1 }) => {
    return Vue.axios.get(`/api/articles/tag/${id}/?page=${page}`)
  },
  // 更多净值
  getJingZhi: (params) => {
    return Vue.axios.get(`/api/products/${params.id}/comparenetvalue/all/`)
  },
  // 信息披露
  getXinPi: (params) => {
    return Vue.axios.get(`/api/products/${params.id}/publish/`)
  },
  // 获取基金产品基本信息
  getProductBasic: (params) => {
    return Vue.axios.get(`/api/products/${params.id}/`)
  },
  // 获取基金产品列表
  getProducts: () => {
    return Vue.axios.get('/api/products/')
  },
  // 个人资产
  getPersonalAssets: () => {
    return Vue.axios.get('/api/customers/asset/')
  },
  // 产品预约
  // productApply: (params) => {
  //   return Vue.axios.post(`/api/products/${params.id}/appointment/`)
  // }
  productApply: (id) => {
    return Vue.axios.post(`/api/products/` + id + `/appointment/`)
  }
}

export default API



// WEBPACK FOOTER //
// ./src/utils/api.js